import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderSettlementModel from "../../models/provider-settlement";

export default class ProviderSettlementRepository extends BaseRepository {
  static modelClass = ProviderSettlementModel;
  modelName = "provider-settlement";

  async getByCase(caseId) {
    await super.query({ case: caseId });
    return await super.getRawData();
  }

  async getStatusOptions() {
    await super.query({ urlPath: "provider_settlement/status_options/" });
    return await super.getRawData();
  }
}
